import { useEffect, useState } from "react";
import { Modal, Show } from "shared/components";
import { ManualApplication } from "./slices/ManualApplication";
import { cx } from "shared/utils";
import { InviteApplicants } from "./slices/InviteApplicants";
import { useLocation, useSearchParams } from "react-router-dom";
import { ApplicantType } from "shared/types";
import { Lead } from "views/leads-id/types";
export const InviteAndCreateModal = ({
  applicationId: _applicationId,
  applicantId: _applicantId,
  propertyName,
  unitName,
  unitId,
  propertyId,
  open,
  setOpen,
  onInviteRefreshKey,
  disabledRoles,
  unitSelectSkipped,
  leadInfo,
  leadId,
  stayOnPage,
  zIndex
}: {
  applicationId?: number;
  applicantId?: number;
  buttonClassName?: string;
  showOnlyEmails?: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
  unitId?: number;
  propertyId?: number;
  onInviteRefreshKey?: unknown[];
  propertyName?: string;
  unitName?: string;
  disabledRoles?: ApplicantType[];
  unitSelectSkipped?: boolean;
  leadInfo?: Pick<Lead, "first_name" | "last_name" | "primary_email">;
  leadId?: number;
  stayOnPage?: boolean;
  /** Lift the modal above a high-z overlay that opened it (the message pop-up). */
  zIndex?: number;
}) => {
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [view, setView] = useState<"invite" | "manual_application">(
    _applicationId && _applicantId ? "manual_application" : "invite"
  );

  const [applicationId, setApplicationId] = useState<number | undefined>(
    _applicationId
  );
  const [applicantId, setApplicantId] = useState<number | undefined>(
    _applicantId
  );

  useEffect(() => {
    setApplicationId(_applicationId);
    setApplicantId(_applicantId);
  }, [_applicationId, _applicantId]);

  const handleClose = () => {
    const shouldClearApplicantId =
      Boolean(searchParams.get("applicantId")) &&
      !pathname.includes("/reports");
    // Invite view navigates to a fresh manualApplicantId right before closing
    const shouldClearManualApplicantId =
      view === "manual_application" &&
      Boolean(searchParams.get("manualApplicantId"));

    if (shouldClearApplicantId || shouldClearManualApplicantId) {
      if (shouldClearApplicantId) searchParams.delete("applicantId");
      if (shouldClearManualApplicantId)
        searchParams.delete("manualApplicantId");
      setSearchParams(searchParams, {
        replace: true
      });
    }
    setOpen(false);
  };

  if (open)
    return (
      <Modal
        opened={open}
        onClose={handleClose}
        zIndex={zIndex}
        panelClassName={cx(
          "w-full transition-all duration-300 mx-4",
          view === "invite"
            ? "max-w-[892px] min-h-[300px] max-h-[calc(100dvh-100px)] flex flex-col"
            : "h-[80vh] max-w-[900px] has-[[data-fit-content]]:h-auto"
        )}
      >
        <Show if={view === "invite"}>
          <InviteApplicants
            disabledRoles={disabledRoles}
            propertyName={propertyName}
            unitName={unitName}
            applicationId={applicationId}
            unitId={unitId}
            propertyId={propertyId}
            setView={setView}
            setOpen={handleClose}
            onSuccess={({ applicationId, applicantId }) => {
              setApplicationId(applicationId);
              setApplicantId(applicantId);
            }}
            onInviteRefreshKey={onInviteRefreshKey}
            unitSelectSkipped={
              unitSelectSkipped !== undefined
                ? unitSelectSkipped
                : Boolean(unitId) && Boolean(propertyId)
            }
            leadInfo={leadInfo}
            leadId={leadId}
            stayOnPage={stayOnPage}
          />
        </Show>

        <Show if={view === "manual_application"}>
          <ManualApplication
            setOpen={handleClose}
            applicationId={applicationId}
            applicantId={applicantId}
          />
        </Show>
      </Modal>
    );

  return null;
};
